<section>
  <button nz-button nzType="primary" (click)="complete()">
    {{ 'SAVE' | translate }}
  </button>
  <button nz-button [disabled]="!hasSelected" (click)="resetSelected()">
    {{ 'RESET_SELECTED' | translate }}
  </button>
  <button nz-button (click)="cancel()">
    {{ 'CANCEL' | translate }}
  </button>
</section>

<section>
  <app-lot-add-photo-images-sorter
    #sorter
    [initialImages]="initialImages"
    [noAuctionList]="noAuctionList"
    [grid]="grid"
    [itemHeightPx]="itemHeightPx"
    (hasSelected)="hasSelected = $event"
    (images)="images = $event"
  ></app-lot-add-photo-images-sorter>
</section>
